"use strict";

jQuery(function () {
    if (jQuery(".js-btn-search-load-posts").length) {
        //console.log("existe");
        jQuery(".js-btn-search-load-posts").on('click', function (e) {
            e.preventDefault();
            jQuery(this).prop("disabled", true);
            var paged = parseInt(jQuery(this).attr('data-paged'));
            var query_string = jQuery(this).attr('data-query-string');
            var posts_per_page = parseInt(jQuery(this).attr('data-posts-per-page'));
            var max_num_pages = parseInt(jQuery(this).attr('data-max-num-pages'));
            var html_response = "";


            //console.log("query = " + query_string);

            var counter = 1;
            var url_parameters = "search=" + query_string + "&posts_per_page=" + posts_per_page + "&paged=" + paged;
            //let url = window.location.origin + "/wp-json/wp/v2/search?" + url_parameters;
            var url = window.location.origin + "/wp-content/themes/southern/search-json.php?" + url_parameters;
            jQuery.ajax({
                //url: "http://freeway.test/api/knowledge/get-paged-posts.php",
                //url: window.location.origin + "/api/posts/last-posts-cats-"+cat+".json",
                url: url,
                type: "GET",
                async: false,
                //dataType: "jsonp",
                success: function success(data) {
                    //console.log(data);
                    // obj = $.parseJSON( '{ "name": "John" }' );
                    jQuery("ul.c-search-results__list").append(data);

                }
            });
            /*
            console.log(paged);
            console.log(max_num_pages);
            console.log(paged >= max_num_pages);
             */
            if(paged >= max_num_pages){
                jQuery(".js-btn-search-load-posts").hide();
            }
            paged++; 
            jQuery(".js-btn-search-load-posts").attr('data-paged',paged);
        });
    }
});